/* eslint-disable react/jsx-no-target-blank */
import { useUser } from '@folklore/auth';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../../lib/PropTypes';
import { getComponentFromName } from '../../../lib/utils';

import { useTheme, useThemeClassName } from '../../../contexts/ThemeContext';
import MillerLite from '../../icons/logos/MillerLite';
import * as LogoComponents from '../../icons/logos/index';
import Menu from '../../menus/Menu';

import styles from '../../../../styles/themes/nfl/footer-nfl.module.scss';

import Yeold from '../../../../img/nfl/yeold-will-logo.png';

const propTypes = {
    className: PropTypes.string,
    menuClassName: PropTypes.string,
    menuItemsClassName: PropTypes.string,
    menuItems: AppPropTypes.menuItems,
    onMenuItemClick: PropTypes.func,
    withoutDisclaimer: PropTypes.bool,
};

const defaultProps = {
    className: null,
    menuClassName: null,
    menuItemsClassName: null,
    menuItems: null,
    onMenuItemClick: null,
    withoutDisclaimer: false,
};

function FooterNFL({
    className,
    menuClassName,
    menuItemsClassName,
    menuItems,
    onMenuItemClick,
    withoutDisclaimer,
}) {
    const themeClassName = useThemeClassName(styles);
    const { footer = null, isVariant } = useTheme();
    const { beerPartnersLogo = null } = footer || {};
    const LogoComponent = getComponentFromName(LogoComponents, beerPartnersLogo, 'miller-lite');
    const user = useUser();
    const { lastPincode = null } = user || {};
    const { groups: pincodeGroups = null } = lastPincode || {};
    const isYeOlde = isVariant('yeold') || (pincodeGroups || []).indexOf('yeold') !== -1;
    return (
        <footer
            className={classNames([
                styles.container,
                {
                    [styles.withoutDisclaimer]: withoutDisclaimer,
                },
                themeClassName,
                className,
            ])}
        >
            {!withoutDisclaimer ? (
                <div className={styles.preamble}>
                    {/* <hr /> */}
                    <em>
                        <FormattedMessage
                            defaultMessage="Celebrate responsibly"
                            description="Lite League - Celebrate Responsibly"
                        />
                    </em>
                    <p>
                        <FormattedMessage
                            defaultMessage="Miller Lite communications from Molson Coors Beverage Company are only sent to eligible Canadian consumers who are of legal drinking age.
Do not share with individuals who have not reached the legal drinking age."
                            description="Lite League - Celebrate Responsibly"
                        />
                    </p>
                </div>
            ) : null}

            <div className={styles.inner}>
                <div className={styles.content}>
                    <MillerLite isBlue className={classNames([styles.logo, styles.millerLogo])} />
                    <LogoComponent className={styles.logo} />
                    {isYeOlde ? <img className={styles.yeoldLogo} src={Yeold} alt="yeold" /> : null}
                </div>
                {(menuItems || []).length > 0 ? (
                    <Menu
                        className={classNames([
                            styles.menu,
                            { [menuClassName]: menuClassName !== null },
                        ])}
                        items={menuItems}
                        itemsClassName={menuItemsClassName}
                        onItemClick={onMenuItemClick}
                    />
                ) : null}
            </div>
        </footer>
    );
}

FooterNFL.propTypes = propTypes;
FooterNFL.defaultProps = defaultProps;

export default FooterNFL;
